export type CantidadesPedidoValores = {
  cantidad: number;
  enEspera: number;
  cancelada: number;
};

/** Lee una cantidad del pedido. Conserva decimales para que la validación los rechace. */
export function parseCantidadPedido(raw: string): number {
  const text = String(raw ?? '').trim().replace(',', '.');
  if (!text) return 0;
  const n = Number(text);
  return Number.isFinite(n) ? n : Number.NaN;
}

export function formatCantidadPedido(value: number | null | undefined): string {
  const n = Number(value);
  if (!Number.isFinite(n)) return '0';
  return Math.trunc(n).toLocaleString('es-AR', { maximumFractionDigits: 0 });
}

/**
 * Unidades que se pueden facturar, preparar o convertir.
 * Sin espera ni cancelada devuelve la cantidad tal cual, incluso con decimales.
 */
export function cantidadEntregablePedido(
  cantidad: number | null | undefined,
  cantidadesPES?: number | null,
  cantidadCanc?: number | null,
): number {
  const pedida = Number(cantidad);
  const base = Number.isFinite(pedida) ? pedida : 0;
  const espera = Math.max(0, Math.trunc(Number(cantidadesPES) || 0));
  const cancelada = Math.max(0, Math.trunc(Number(cantidadCanc) || 0));
  if (espera === 0 && cancelada === 0) return base;
  return Math.max(0, Math.trunc(base) - espera - cancelada);
}

/** Devuelve el mensaje de error, o null si la combinación es válida. */
export function validarCantidadesPedido(valores: CantidadesPedidoValores): string | null {
  const cantidad = Number(valores.cantidad);
  const enEspera = Number(valores.enEspera);
  const cancelada = Number(valores.cancelada);
  const todas = [cantidad, enEspera, cancelada];

  if (todas.some((n) => !Number.isFinite(n) || !Number.isInteger(n))) {
    return 'Las cantidades tienen que ser números enteros.';
  }
  if (cantidad <= 0) {
    return 'La cantidad del renglón tiene que ser mayor a 0.';
  }
  if (enEspera < 0 || cancelada < 0) {
    return 'En espera y cancelada no pueden ser negativas.';
  }
  if (enEspera + cancelada > cantidad) {
    return 'La suma de en espera y cancelada no puede superar la cantidad del renglón.';
  }
  return null;
}
